@if (displayedForms() | includes: 'siret') {
  <div tiimeFormGrid>
    <tiime-input-container contentId="siret" label="Numéro de SIRET" [errorMessage]="companyForm.siretErrorMessage">
      <input
        #companySiretInput
        id="siret"
        type="text"
        placeholder="Numéro de SIRET"
        formControlName="siret"
        [inputMask]="siretMask"
        autocomplete="off"
        data-cy="create-company-siret-input"
      />
    </tiime-input-container>
  </div>
  @if ((displayedForms() | includes: 'company') || (displayedForms() | includes: 'address')) {
    <div tiimeFormVerticalSeparator></div>
  }
}
@if (displayedForms() | includes: 'company') {
  <div tiimeFormTitle>Informations Entreprise</div>
  <div tiimeFormGrid>
    <tiime-input-container contentId="name" label="Nom" [errorMessage]="companyForm.nameErrorMessage">
      <input
        #companyNameInput
        id="name"
        type="text"
        placeholder="Nom"
        formControlName="name"
        autocomplete="off"
        data-cy="create-company-name-input"
      />
    </tiime-input-container>
    <app-business-unit-select
      [selectData]="businessUnits()"
      [control]="companyForm.businessUnit"
      [errorMessage]="companyForm.businessUnitErrorMessage"
    ></app-business-unit-select>
    <div class="two-cell-grid">
      <tiime-input-container
        contentId="reference"
        label="Numéro de dossier"
        [errorMessage]="companyForm.referenceErrorMessage"
      >
        <input
          id="reference"
          type="text"
          placeholder="Numéro de dossier"
          formControlName="reference"
          appUppercaseInput
          autocomplete="off"
          data-cy="create-company-reference-input"
        />
      </tiime-input-container>
      <app-legal-form-select
        contentId="legalform"
        [errorMessage]="companyForm.legalFormErrorMessage"
        [selectData]="legalForms()"
        [control]="companyForm.legalForm"
      ></app-legal-form-select>
    </div>
    <app-company-legal-structure-and-signatory-select
      *appHasRole
      [selectData]="legalStructuresAndSignatories()"
      [control]="companyForm.legalStructureAndSignatory"
    ></app-company-legal-structure-and-signatory-select>
    <app-ape-code-select
      [selectData]="apeCodes()"
      [control]="companyForm.apeCode.id"
      [errorMessage]="companyForm.apeCodeErrorMessage"
    ></app-ape-code-select>
  </div>
  @if (displayedForms() | includes: 'address') {
    <div tiimeFormVerticalSeparator></div>
  }
}
@if (displayedForms() | includes: 'address') {
  <div tiimeFormTitle>Adresse</div>
  <div tiimeFormGrid>
    <tiime-input-container contentId="street" label="Numéro et nom de la voie">
      <input
        id="street"
        type="text"
        placeholder="Numéro et nom de la voie"
        formControlName="street"
        autocomplete="off"
        data-cy="create-company-street-input"
      />
    </tiime-input-container>
    <tiime-input-container contentId="postalCode" label="Code postal">
      <input
        id="postalCode"
        type="text"
        placeholder="Code postal"
        formControlName="postalCode"
        autocomplete="off"
        data-cy="create-company-postal-code-input"
      />
    </tiime-input-container>
    <tiime-input-container contentId="city" label="Ville">
      <input
        id="city"
        type="text"
        placeholder="Ville"
        formControlName="city"
        autocomplete="off"
        data-cy="create-company-city-input"
      />
    </tiime-input-container>
  </div>
}
